<template lang="pug">
  v-container#header(fluid)
    v-layout(row wrap)
      v-flex(xs12)
        v-card.pb-3.pt-1(flat)
          v-layout(row wrap)
            v-flex(d-flex xs5 md3 lg2 align-center)
              router-link.home(to="/")
                img.logo(src="/static/logo.jpeg")
            v-flex(d-flex xs7 md3)
              router-link.home(to="/")
                v-card-title.header-title.ml-3 Asesorías
            v-flex(d-flex align-center).text-xs-right.justify-end
              v-btn.mx-2.short-btn.dark.bold(@click="downloadData('advisories')") Descargar datos de asesorías
              v-btn.mx-2.short-btn.dark.bold(@click="downloadData('victims')") Descargar datos de víctimas
              v-btn.mx-2.header-btn.bold(outline color="green darken-3" to="/users" v-if="userPermissions.createUser") Administrar accesos
              p.ml-2.mr-4.salir.bolder(@click="logout") Salir 
    v-divider
</template>

<script>
import axios from "axios";

export default {
  name: "Header",
  props: {},
  computed: {
    userPermissions () {
      return this.$store.getters.user.permission;
    },
  },
  methods: {
    logout() {
      this.$store.commit("resetUser");
      localStorage.clear();
      this.$store.dispatch("logout");
      delete axios.defaults.headers.post['X-CSRF-Token'];
      delete axios.defaults.headers.delete['X-CSRF-Token'];
      delete axios.defaults.headers.put['X-CSRF-Token'];
      this.$router.replace("/login");
    },
    downloadData(type) {
      switch(type){
        case 'advisories':
          window.open('https://s3.amazonaws.com/media.frayjuandelarios.org/Reportes.csv', '_blank');
          break;
        case 'victims': 
          window.open('https://s3.amazonaws.com/media.frayjuandelarios.org/Victimas.csv', '_blank');
          break;
        default:
          window.open('https://s3.amazonaws.com/media.frayjuandelarios.org/Reportes.csv', '_blank');
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
#header {
  .logo {
    max-width: 100%;
  }
  .home {
    text-decoration: none;
  }
  .salir {
    text-decoration: underline;
    max-width: fit-content;
    font-size: 17px;
    &:hover {
      cursor: pointer;
    }
  }

  .header-btn {
    max-width: fit-content;
    border-radius: 10px;
    font-family: 13px;
    font-weight: 700;
    box-shadow: none;
    height: 41px;
    width: 180px !important;
    white-space: normal !important;
    & /deep/ .btn__content {
      font-size: 14px;
      line-height: 15px;
    }
  }

  .short-btn {
    max-width: 187px;
    border-radius: 10px;
    font-family: 13px;
    font-weight: 700;
    box-shadow: none;
    height: 41px;
    & /deep/ .btn__content {
      width: 180px !important;
      white-space: normal !important;
      font-size: 14px;
      line-height: 15px;
    }
  }

  .dark {
    background-color: #ca0588;
    color: #fff;
  }
}
</style>
